import { RefreshCcw } from 'lucide-react';
import PropTypes from "prop-types";



const BotErrorBox = ({ t, onRegenerate }) => (
    <div className="flex flex-col items-center justify-center flex-1 bg-red-50 dark:bg-[#2a1a1a] rounded-xl shadow-lg text-gray-900 dark:text-white p-6 transition-all duration-300 border border-red-200 dark:border-red-600">
        <p className="text-base font-medium text-center text-red-700 dark:text-red-300 max-w-sm">
            {t('noResponse') || "We couldn’t get a response at the moment. Please try again or check your internet connection."}
        </p>
        <button
            onClick={onRegenerate}
            className="mt-5 flex items-center gap-2 px-4 py-2 bg-red-600 hover:bg-red-700 text-white text-sm font-medium rounded-md shadow transition duration-200"
        >
            <RefreshCcw className="w-4 h-4" />
            {t('tryAgain')}
        </button>
    </div>
);

BotErrorBox.propTypes = {
    t: PropTypes.func.isRequired,
    onRegenerate: PropTypes.func.isRequired,
};

export default BotErrorBox;
